import React, { useState, useRef, useEffect } from 'react';

const ImageSelector = ({ images, selectedImage, onImageSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selectedImageData = images.find(img => img.id === selectedImage);
  const displayText = selectedImageData ? selectedImageData.name : "-- Choose an image --";

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSelect = (imageId) => {
    onImageSelect(imageId);
    setIsOpen(false);
  };

  return (
    <div className="image-selector">
      <label className="selector-label">
        Select Container Image:
      </label>
      <div className="custom-dropdown" ref={dropdownRef}>
        <button 
          className="dropdown-trigger"
          onClick={() => setIsOpen(!isOpen)}
          aria-expanded={isOpen}
        >
          <span className="dropdown-text">{displayText}</span>
          <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</span>
        </button>
        
        {isOpen && (
          <div className="dropdown-menu">
            {images.map(image => (
              <button
                key={image.id}
                className={`dropdown-item ${selectedImage === image.id ? 'selected' : ''}`}
                onClick={() => handleSelect(image.id)}
              >
                {image.name}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageSelector;